import EntityHelper from '../helpers/entity';

export default class MachineCountType {
  constructor(data) {
    EntityHelper.validateData(data);
    const {
      // eslint-disable-next-line camelcase
      id, mct_id, name, mct_name,
    } = data;
    // eslint-disable-next-line camelcase
    this.id = EntityHelper.setId(id || mct_id);
    // eslint-disable-next-line camelcase
    this.name = name || mct_name;
  }
}
